import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import Cookies from "js-cookie";
import moment from "moment";
import qs from "qs";

import {
  AxiosCustomGet,
  AxiosCustomPost,
} from "../../../../components/axios/AxiosCustom";
import Config from "../../../../components/axios/Config";
import Title from "../../../../components/common/Title/Title";
import Breadcrumb from "../../../../components/common/Breadcrumb/Breadcrumb";
import TextInput from "../../../../components/common/TextInput/TextInput";
import MultipleSelect from "../../../../components/common/MultipleSelect/MultipleSelect";
import ButtonInput from "../../../../components/common/Button/ButtonInput";
import CustomDatePicker from "../../../../components/common/DatePicker/CustomDatePicker";
import FilterButton from "../../../../components/common/Button/FilterButton";
import CustomTable from "../../../../components/common/Table/CustomTable";
import ExportButton from "../../components/ExportButton";
import ActiveOutlets from "../../components/ActiveOutlets/ActiveOutlets";
import TotalSummary from "./components/TotalSummary";
import ChooseColumnDialog from "./components/ChooseColumnDialog";
import ChooseOutletDialog from "../../components/ChooseOutletDialog";
import SwalToast from "../../../../components/helpers/SwalToast";
import { NavLink } from "react-router-dom";

import {
  convertCategory,
  convertOutletList,
  convertTenor,
} from "../../helpers";
import { convertGadaiReport, convertReportStatus } from "../helpers";

import {
  pawnTransactionInitFilterInput,
  pawnTransactionStatusList,
  pawnReportColumns,
} from "../constants";
import {
  initCategoryAndTenor,
  initPaymentAndTenorType,
  paymentTypeList,
  tenorTypeList,
} from "../../constants";

import "../../styles.css";
import { CurrencyFormat } from "../../../../components/helpers";
import { AuthorizationList, CanAccess } from "../../../../components/template/authorization/Authorization";

const PawnTransactionReport = () => {
  const [gadaiReportList, setGadaiReportList] = useState([]);
  const [tableColumns, setTableColumns] = useState([]);
  const [isChangeColumnDialogOpen, setIsChangeColumnDialogOpen] =
    useState(false);
  const [isOutletDialogOpen, setIsOutletDialogOpen] = useState(false);
  const [columnCheckedList, setColumnCheckedList] = useState([]);
  const [columnList, setColumnList] = useState([]);
  const [columnIndeterminate, setColumnIndeterminate] = useState(false);
  const [columnCheckAll, setColumnCheckAll] = useState(false);
  const [outletCheckedList, setOutletCheckedList] = useState([]);
  const [outletIndeterminate, setOutletIndeterminate] = useState(false);
  const [outletCheckAll, setOutletCheckAll] = useState(false);

  const [transactionStatusCount, setTransactionStatusCount] = useState(
    pawnTransactionStatusList
  );
  const [isChangingType, setIsChangingType] = useState(false);
  const [filterInput, setFilterInput] = useState(
    pawnTransactionInitFilterInput
  );
  const [selectedCategory, setSelectedCategory] =
    useState(initCategoryAndTenor);
  const [selectedPaymentType, setSelectedPaymentType] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenorType, setSelectedTenorType] = useState(
    initPaymentAndTenorType
  );
  const [selectedTenor, setSelectedTenor] = useState(initCategoryAndTenor);
  const [transactionDateValue, setTransactionDateValue] = useState([]);
  // const [extensionDateValue, setExtensionDateValue] = useState([]);
  const [pageSizeValue, setPageSizeValue] = useState(10);
  const [searchNameValue, setSearchNameValue] = useState("");
  const [categoryList, setCategoryList] = useState([]);
  const [outletList, setOutletList] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [loading, setLoading] = useState(false);
  const [tenorList, setTenorList] = useState([]);
  const [financialData, setFinancialData] = useState({});

  const getTenorList = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}tenors`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setTenorList(convertTenor(response.data.data));
      }
    );
  };

  const getCategory = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}product-categories`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setCategoryList(convertCategory(response.data.data.items));
      }
    );
  };

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));

        const outletListId = response.data.data.map((outlet) => {
          return outlet.id;
        });

        setOutletCheckedList(outletListId);
        setOutletIndeterminate(false);
        setOutletCheckAll(true);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data outlet: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getTotalSummary = () => {
    setLoading(true);
    const data = {
      tenor_days: filterInput.tenor,
      product_category_id: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      search: filterInput.searchName,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      outlet_id: filterInput.outlets,
      status: [filterInput.transactionStatus],
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}gadai-report/widget`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setFinancialData({
          totalExpenditure: `Rp ${
            CurrencyFormat(response?.data?.data?.expense) || 0
          }`,
          totalIncome: `Rp ${
            CurrencyFormat(response?.data?.data?.income) || 0
          }`,
          totalProfit: `Rp ${
            CurrencyFormat(response?.data?.data?.profit) || 0
          }`,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data total: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getGadaiReportList = () => {
    setLoading(true);
    const data = {
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      tenor_days: filterInput.tenor,
      product_category_id: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      search: filterInput.searchName,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      outlet_id: filterInput.outlets,
      status: [filterInput.transactionStatus],
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai-report`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        const responseData = response?.data?.data;

        // setFinancialData({
        //   totalExpenditure: `Rp ${
        //     CurrencyFormat(responseData?.financial_data?.total_expenditure) || 0
        //   }`,
        //   totalIncome: `Rp ${
        //     CurrencyFormat(responseData?.financial_data?.total_income) || 0
        //   }`,
        //   totalProfit: `Rp ${
        //     CurrencyFormat(responseData?.financial_data?.total_profit) || 0
        //   }`,
        // });

        const countData = {
          ongoing: responseData?.total_ongoing,
          done: responseData?.total_done,
          "payment-late": responseData?.total_payment_late,
          extended: responseData?.total_extended,
          "payment-failed": responseData?.total_payment_failed,
          "auction-progress": responseData?.total_auction_progress,
          "auction-done": responseData?.total_auction_done,
        };

        setLoading(false);
        setGadaiReportList(convertGadaiReport(responseData?.items));

        if (!isChangingType) {
          setTransactionStatusCount(
            convertReportStatus(
              pawnTransactionStatusList,
              countData,
              filterInput.transactionStatus
            )
          );
        }

        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });

        setIsChangingType(false);
        getTotalSummary();
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data transaksi: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTextInputChange = (event) => {
    const { name, value } = event.target;

    if (name === "pageSize") {
      setPageSizeValue(value);
    } else {
      setSearchNameValue(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
    (event) => {
      const { name, value } = event.target;
      if (event.keyCode === 13 || type === "blur") {
        if (name === "pageSize" && value === "") {
          setPageSizeValue(10);
        }
        setFilterInput((prev) => ({
          ...prev,
          [name]: name === "pageSize" && value === "" ? 10 : value,
          page: 1,
        }));
      }
    };

  const handleSelectChange = (field, data) => {
    if (field === "category") {
      setSelectedCategory({
        value: data.value,
        label: data.label,
      });
    } else if (field === "paymentType") {
      setSelectedPaymentType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenorType") {
      setSelectedTenorType({
        value: data.value,
        label: data.label,
      });
    } else if (field === "tenor") {
      setSelectedTenor({
        value: data.value,
        label: data.label,
      });
    }

    setFilterInput((prev) => ({
      ...prev,
      [field]: data.value,
      page: 1,
    }));
  };

  const handleDateChange = (event, id) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    if (id === "transactionDate") {
      setTransactionDateValue(event ? [startDate, endDate] : null);
      setFilterInput((prev) => ({
        ...prev,
        transactionStartDate: event ? new Date(startDate) : null,
        transactionEndDate: event ? new Date(endDate) : null,
        page: 1,
      }));
    }
    // else if (id === "extensionDate") {
    //   setExtensionDateValue(event ? [startDate, endDate] : null);
    //   setFilterInput((prev) => ({
    //     ...prev,
    //     extensionStartDate: event ? new Date(startDate) : null,
    //     extensionEndDate: event ? new Date(endDate) : null,
    //     page: 1,
    //   }));
    // }
  };

  const handleTransactionStatusChange = (e) => {
    setIsChangingType(true);
    const currentValue = e.target.value;

    setTransactionStatusCount((prev) => {
      const temp = [...prev];
      temp.map((transType) => {
        transType.active = currentValue === transType.value ? true : false;
        return transType;
      });
      return temp;
    });

    setFilterInput((prev) => ({
      ...prev,
      transactionStatus: currentValue,
      page: 1,
    }));
  };

  const handleExport = (type) => (e) => {
    if (type === "excel") {
      handleExportExcel();
    }
  };

  const handleExportExcel = () => {
    let data = {
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize),
      tenor_days: filterInput.tenor,
      product_category_id: filterInput.category,
      payment_type: filterInput.paymentType,
      tenor_type: filterInput.tenorType,
      search: filterInput.searchName,
      sorting_field: filterInput.sortingField,
      sorting_order: filterInput.sortingOrder,
      start_date_transaction: filterInput.transactionStartDate,
      end_date_transaction: filterInput.transactionEndDate,
      outlet_id: filterInput.outlets,
      status: [filterInput.transactionStatus],
    };
    let filename = "daftar_gadai.xlsx";
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai-report/excel`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "content-type":
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
        data,
        (params) => {
          return qs.stringify(filterNonNull(params), { arrayFormat: "repeat" });
        },
        "blob"
      ),
      (response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
        });
        var link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      (error) => {
        console.log("handleExportExcel", error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal export data menjadi excel: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  function filterNonNull(obj) {
    return Object.fromEntries(Object.entries(obj).filter(([k, v]) => v));
  }

  const handleOutletButtonClick = () => {
    setIsOutletDialogOpen(true);
  };

  const handleChangeColumnButtonClick = () => {
    setIsChangeColumnDialogOpen(true);
  };

  const handleCancel = () => {
    setIsChangeColumnDialogOpen(false);
    setIsOutletDialogOpen(false);
  };

  const handleColumnSave = () => {
    const initialColumns = pawnReportColumns;

    const newColumns = initialColumns.filter(
      (column) =>
        columnCheckedList.includes(column.title) || column.key === "action"
    );

    setTableColumns(newColumns);
    setIsChangeColumnDialogOpen(false);
  };

  const handleColumnCheckAllChange = (event) => {
    setColumnCheckedList(event.target.checked ? columnList : []);
    setColumnIndeterminate(false);
    setColumnCheckAll(event.target.checked);
  };

  const handleSingleColumnChange = (list) => {
    setColumnCheckedList(list);
    setColumnIndeterminate(!!list.length && list.length < columnList.length);
    setColumnCheckAll(list.length === columnList.length);
  };

  const handleOutletSave = () => {
    setFilterInput((prev) => ({
      ...prev,
      outlets: outletCheckedList,
      page: 1,
    }));
    setIsOutletDialogOpen(false);
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    setOutletCheckedList(event.target.checked ? outletListId : []);
    setOutletIndeterminate(false);
    setOutletCheckAll(event.target.checked);
  };

  const handleSingleOutletChange = (list) => {
    setOutletCheckedList(list);
    setOutletIndeterminate(!!list.length && list.length < outletList.length);
    setOutletCheckAll(list.length === outletList.length);
  };

  const handleReset = () => {
    setSelectedCategory(initCategoryAndTenor);
    setSelectedTenor(initCategoryAndTenor);
    setSelectedTenorType(initPaymentAndTenorType);
    setSelectedPaymentType(initPaymentAndTenorType);
    setSearchNameValue("");
    setPageSizeValue(10);
    setTransactionDateValue([]);
    // setExtensionDateValue([]);

    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    setOutletCheckedList(outletListId);
    setOutletIndeterminate(false);
    setOutletCheckAll(true);

    setFilterInput(pawnTransactionInitFilterInput);
  };

  const handleTableChange = (pagination, _, sorter) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
      sortingField: sorter?.column?.backend_key || null,
      sortingOrder:
        sorter?.order === "ascend"
          ? "ASC"
          : sorter?.order === "descend"
          ? "DESC"
          : null,
    }));
  };

  useEffect(() => {
    const columns = pawnReportColumns;
    setTableColumns(columns); // for columns in CustomTable

    const listColumns = columns
      .filter((column) => column.title !== "Aksi")
      .map((column) => column.title);

    setColumnList(listColumns); // for list columns in ChooseColumnDialog
    setColumnCheckedList(listColumns);
    setColumnIndeterminate(false);
    setColumnCheckAll(true);

    getCategory();
    getTenorList();
    getOutlet();
  }, []);

  const getMonthly = () => {
    let startOfMonth = moment().startOf("month");
    let endOfMonth = moment();

    setTransactionDateValue([startOfMonth, endOfMonth]);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: new Date(startOfMonth),
      transactionEndDate: new Date(endOfMonth),
    }));
  };

  useEffect(() => {
    if (transactionDateValue) {
      getGadaiReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterInput]);

  useEffect(() => {
    getMonthly();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
          <Title text={"Daftar Gadai"} />
          <Breadcrumb current={"Daftar Gadai"} />
        </div>

        <div className="d-flex justify-content-between filter-bar">
          <TextInput
            id={"pageSize"}
            label={"Tampilkan"}
            width={"7%"}
            handleEnter={handleEnter}
            value={pageSizeValue}
            handleChange={handleTextInputChange}
          />
          <TextInput
            id={"searchName"}
            label={"No. SBG / No. Kwitansi / Nama Nasabah"}
            width={"30%"}
            placeholder={"Cari.."}
            handleEnter={handleEnter}
            value={searchNameValue}
            handleChange={handleTextInputChange}
          />
          <MultipleSelect
            id={"category"}
            label={"Kategori Produk"}
            isSearchable={true}
            onSelectChange={handleSelectChange}
            options={categoryList}
            value={selectedCategory}
          />
          <MultipleSelect
            id={"paymentType"}
            label={"Jenis Pembayaran"}
            onSelectChange={handleSelectChange}
            options={paymentTypeList}
            value={selectedPaymentType}
          />
          <MultipleSelect
            id={"tenorType"}
            label={"Jenis Tenor"}
            options={tenorTypeList}
            onSelectChange={handleSelectChange}
            value={selectedTenorType}
          />
          <div className="filter-bar">
            <Button
              variant="link"
              className="btn-action btn-reset"
              onClick={handleReset}
            >
              Reset semua filter
            </Button>
          </div>
        </div>

        <div className="d-flex filter-bar-2">
          <MultipleSelect
            id={"tenor"}
            label={"Tenor"}
            onSelectChange={handleSelectChange}
            options={tenorList}
            value={selectedTenor}
          />
          <ButtonInput
            id={"outlet"}
            label={"Cabang/Outlet"}
            buttonText={"Pilih Cabang"}
            onButtonClick={handleOutletButtonClick}
            variant={"outline-secondary"}
            width={"13%"}
          />
          <CustomDatePicker
            id={"transactionDate"}
            label={"Tanggal Transaksi"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={transactionDateValue}
          />
          {/* <CustomDatePicker
            id={"extensionDate"}
            label={"Tanggal Perpanjangan"}
            isRangePicker
            width="20%"
            onInputChange={handleDateChange}
            value={extensionDateValue}
          /> */}
        </div>

        <div className="d-flex filter-bar-2 align-items-center mt-2 mb-4">
          <span style={{ fontSize: "15px" }}>Status:</span>
          {transactionStatusCount.map((transactionStatus) => {
            return (
              <FilterButton
                data={transactionStatus}
                handleChange={handleTransactionStatusChange}
                type="transactionType"
              />
            );
          })}
        </div>

        <div>
          <TotalSummary data={financialData} />
        </div>

        <div
          className="d-flex filter-bar filter-bar-2"
          style={{ margin: "1.5rem 0" }}
        >
          <Button
            className="btn-detail btn-action"
            type="text"
            variant={"primary"}
            onClick={handleChangeColumnButtonClick}
          >
            Ubah Kolom
          </Button>
          <div className="ml-auto">
            <ActiveOutlets
              outletList={outletList}
              activeOutlets={outletCheckedList}
            />
          </div>
        </div>

        <CustomTable
          columns={[
            ...tableColumns,
            {
              dataIndex: "action",
              key: "action",
              title: "Aksi",
              render: (_, record) => (
                <div style={{ textAlign: "center", display: "grid" }}>
                  <CanAccess
                    role={AuthorizationList.view_gadai}
                    yes={
                      <NavLink to={`/report/pawn/${record.gadaiID}`}>
                        <Button
                          variant="primary"
                          className="btn-action btn-detail"
                        >
                          Detail
                        </Button>
                      </NavLink>
                    }
                  />
                </div>
              ),
            },
          ]}
          scrollX={"max-content"}
          data={gadaiReportList}
          loading={loading}
          handleTableChange={handleTableChange}
          pagination={tablePagination}
        />

        <div className="filter-bar-2 d-flex" style={{ marginTop: "2rem" }}>
          <ExportButton
            handleExport={handleExport}
            pathname="/report/pawn-list/export"
            data={gadaiReportList}
            from="cash"
            columns={tableColumns}
          />
        </div>
      </div>

      <ChooseColumnDialog
        title={"Pilih Atribut/Kolom"}
        visible={isChangeColumnDialogOpen}
        handleSave={handleColumnSave}
        handleCancel={handleCancel}
        data={columnList}
        onCheckAllChange={handleColumnCheckAllChange}
        onSingleChange={handleSingleColumnChange}
        indeterminate={columnIndeterminate}
        columnCheckAll={columnCheckAll}
        columnCheckedList={columnCheckedList}
      />

      <ChooseOutletDialog
        title={"Pilih Cabang/Outlet"}
        visible={isOutletDialogOpen}
        handleSave={handleOutletSave}
        handleCancel={handleCancel}
        data={outletList}
        onCheckAllChange={handleOutletCheckAllChange}
        onSingleChange={handleSingleOutletChange}
        indeterminate={outletIndeterminate}
        outletCheckAll={outletCheckAll}
        outletCheckedList={outletCheckedList}
      />
    </div>
  );
};

export default PawnTransactionReport;
